import { render, staticRenderFns } from "./ComprasSubBanner.vue?vue&type=template&id=381a8916&scoped=true"
import script from "./ComprasSubBanner.vue?vue&type=script&lang=js"
export * from "./ComprasSubBanner.vue?vue&type=script&lang=js"
import style0 from "./ComprasSubBanner.vue?vue&type=style&index=0&id=381a8916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381a8916",
  null
  
)

export default component.exports